import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var DiamondEmptyIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M15.776 4h-7.5c-.565 0-1.114.136-1.603.388-.464.24-.82.606-1.197 1.012L1.92 9.092a3 3 0 00.279 3.92l7.679 7.681a3 3 0 003.961.249l.097-.08.094-.083.054-.121.036.036 7.68-7.68a3 3 0 00.279-3.921L18.576 5.4c-.751-.73-1.699-1.4-2.8-1.4zm0 2a1.5 1.5 0 011.1.48l.1.12 3.503 3.693a1 1 0 01-.012 1.215l-.081.092-7.68 7.68-.094.083a1 1 0 01-1.226 0l-.094-.084-7.679-7.68a1 1 0 01-.16-1.205l.067-.102L7.076 6.6a1.5 1.5 0 011.044-.592L8.276 6h7.5z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
DiamondEmptyIcon.isCarinaIcon = true;
export default DiamondEmptyIcon;
